module.exports = __webpack_public_path__ + "static/media/Christmas_RewardBackground.9bb865a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/reward-background/Christmas_RewardBackground.png
// module id = 1355
// module chunks = 3